exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center[data-v-73accc8b] {\n    margin: auto;\n    width: 50%;\n    border: 3px solid green;\n    padding: 10px;\n}\ntextarea[data-v-73accc8b] {\n    resize: none;\n}\n.green-color[data-v-73accc8b] {\n  color: green;\n}\n.fa-check[data-v-73accc8b] {\n  color: green;\n}\n.fa-times[data-v-73accc8b] {\n  color: red\n}\n.exercise-body[data-v-73accc8b], .exercise-item[data-v-73accc8b] {\n  padding-left: 1ex;\n}\n.small-button[data-v-73accc8b]{\n  padding-left: 1em !important;\n  padding-right: 1em !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-73accc8b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exercises/types/Essay.vue
// module id = 942
// module chunks = 1